module.exports = __webpack_public_path__ + "media/images/copy-icon-cb32c20327b9b9dddfcf33b7737bd367.svg";